// @flow

import styled, { css } from 'styled-components';

export const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${props => props.vertical && css`
    align-items: initial;
  `}
`;
